import { cloneDeep } from "lodash";
import { getMutableComponentProps } from "./utils";
export const addCustomFieldsToGridProps = (componentProps, allDependencies, originalComponentProps, argument) => {
    const customDimensions = allDependencies.customDimensions?.[argument?.entityType || ""] || [], { switched } = allDependencies;
    if (customDimensions.length === 0 || !componentProps) {
        return componentProps;
    }
    const customDimensionFieldName = (cd) => `${cd.id}Grouping`.replace(/\./ug, ""), mutableComponentProps = getMutableComponentProps(componentProps, originalComponentProps);
    const gridSwitcher = mutableComponentProps?.gridSwitcher;
    const columns = (switched && gridSwitcher?.columnsTemplate ? gridSwitcher.columnsTemplate : mutableComponentProps.columnsTemplate)?.columns;
    columns?.push({
        children: customDimensions.map((cd) => ({
            enableRowGroup: true,
            field: customDimensionFieldName(cd),
            headerName: cd.metadata?.label?.toString(),
            hide: true,
            lockVisible: true,
            type: "auxTextColumn"
        }))
    });
    const params = switched && gridSwitcher ? gridSwitcher.datapointParams : mutableComponentProps.datapointParams;
    params?.forEach((dpp) => {
        dpp.measures = dpp.measures?.concat(customDimensions.map((cd) => ({
            customDatapoint: cd.id,
            name: customDimensionFieldName(cd),
            periods: 1
        })));
    });
    return mutableComponentProps;
};
const DEFAULT_CUSTOM_FIELDS_TEMPLATE = { dimensions: [{ name: "CUSTOM_DIM" }] };
const isDimensionSelector = (sp) => Object.values(sp.selectValues || {}).some((sv) => (sv?.datapointParams?.[0]?.dimensions?.length ?? 0) > 0);
const resolveTemplates = (sp) => {
    const templates = sp.customFieldsDatapointParams;
    if (templates && templates.length > 0) {
        return templates;
    }
    /*
     * Auto-inject custom fields into dimension-based selectors that
     * do not explicitly declare a customFieldsDatapointParams template.
     */
    return isDimensionSelector(sp) ? [DEFAULT_CUSTOM_FIELDS_TEMPLATE] : undefined;
};
const assignCustomDatapoint = (entries, customDatapointId) => {
    entries?.forEach((d) => {
        if (!d.standardDatapoint) {
            d.customDatapoint = customDatapointId;
        }
    });
};
const buildCustomSelectValue = (template, cd, groupName) => {
    const csvp = {
        datapointParams: cloneDeep([template]),
        displayName: cd.metadata?.label?.toString() || "",
        groupName
    };
    csvp.datapointParams?.forEach((dp) => {
        assignCustomDatapoint(dp.measures, cd.id);
        assignCustomDatapoint(dp.dimensions, cd.id);
    });
    return csvp;
};
const applyCustomDimensionsToSelector = (sp, customDimensions, groupName) => {
    const templates = resolveTemplates(sp);
    if (!templates) {
        return;
    }
    templates.forEach((cp) => {
        customDimensions.forEach((cd) => {
            sp.selectValues[cd.id || ""] = buildCustomSelectValue(cp, cd, groupName);
        });
    });
};
export const addCustomFieldsToSelValues = (componentProps, allDependencies, originalComponentProps, argument) => {
    const customDimensions = allDependencies.customDimensions?.[argument?.entityType || ""] || [];
    if (customDimensions.length === 0 || !componentProps ||
        !componentProps.dataSelectProps || componentProps.dataSelectProps.length === 0) {
        return componentProps;
    }
    const mutableComponentProps = getMutableComponentProps(componentProps, originalComponentProps);
    mutableComponentProps.dataSelectProps?.forEach((sp) => {
        applyCustomDimensionsToSelector(sp, customDimensions, argument?.groupName);
    });
    return mutableComponentProps;
};
